import { useTranslation } from 'react-i18next';
import { Wrapper, LangButton } from './LanguageSwitcher.styled';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  return (
    <Wrapper>
      <LangButton
        $active={i18n.language === 'pl'}
        onClick={() => i18n.changeLanguage('pl')}
        aria-label="Polski"
      >
        PL
      </LangButton>
      <LangButton
        $active={i18n.language === 'en'}
        onClick={() => i18n.changeLanguage('en')}
        aria-label="English"
      >
        EN
      </LangButton>
    </Wrapper>
  );
}
